import {Catalog, FileData, FormattedDate} from '../../../../common/types/common';
import {POSViewFieldErrorState} from './reducers';
import {DisplayValue} from '../../../../quote/types/mx/epics';

export enum BankTarget {
    CREDITO_REAL = 'credito-real',
    TURBO_CASH = 'turbo-cash',
    SANTANDER = 'santander',
    FARRERA = 'farrera',
    SEMINUEVOS = 'seminuevos',
    COPPEL = 'coppel',
    MOTORFY = 'motorfy'
}

export enum FinancialEntityType {
    FARRERA = 'FARRERA',
    SEMINUEVOS = 'SEMINUEVOS',
    COPPEL = 'COPPEL',
    MOTORFY = 'MOTORFY'
}

export enum Nationalities {
    MEXICAN_NATIONALITY = 'Mexican',
    FOREIGN_NATIONALITY = 'Foreign'
}
export enum CivilStatuses {
    MARRIED_CIVIL_STATUS = 'Married'
}

export enum HoldingResidenceTitleTypes {
    OWN = 'Own',
    RENTED = 'Rented',
    FAMILY = 'Family',
    MORTGAGED = 'Mortgaged'
}

export enum AcceptQuoteTypes {
    ACCEPTED_QUOTE = 'ACCEPTED_QUOTE',
    NON_ACCEPTED_QUOTE = 'NON_ACCEPTED_QUOTE'
}

export const OTHER = 'OTHER';

export enum EmploymentTypes {
    INDEPENDENT_ID = 'INDEPENDENT',
    INDEPENDENT_VALUE = 'Independiente',
    DEPENDENT_ID = 'DEPENDENT',
    DEPENDENT_VALUE = 'Asalariado'
}

export enum ResourceTypes {
    THIRD_PARTY = 'ThirdParty'
}

export interface VehicleDataState {
    brandSelected: Catalog
    modelSelected: Catalog
    versionSelected: Catalog
    yearSelected: Catalog
    mileage: string,
    assemblyCountrySelected: Catalog
}

export interface VehicleCatalogsState {
    brands: Catalog[]
    models: Catalog[]
    versions: Catalog[]
    years: Catalog[]
}

export interface PersonalDataState {
    firstName: string;
    secondName: string;
    lastName: string;
    secondLastName: string;
    birthDate: string;
    docNumber: string;
    cellPhone: string;
    email: string;
}

export interface CreditConditionDataState {
    openingCommission?: Catalog;
    vehiclePrice: string;
    downPayment: string;
    termSelected: Catalog;
}

export interface InsuranceDataState {
    isFinanced: boolean;
    insuranceAmount: string;
    insuranceCarrierSelected: Catalog;
}

export interface HomeDataState {
    address: string;
    extNumber: string;
    intNumber: string;
    postalCode: string;
    state: Catalog;
    city: Catalog;
    municipality: Catalog;
    selectedColony: Catalog;
    phone?: string;
    houseHoldMeasure?: Catalog;
    houseHoldTime?: Catalog;
}

export interface WorkDataState {
    workplaceName: string;
    position?: string | Catalog;
    workingSince?: string;
    address?: string;
    extNumber?: string;
    intNumber?: string;
    postalCode?: string;
    state?: Catalog;
    city?: Catalog;
    municipality?: Catalog;
    selectedColony?: Catalog;
    workplacePhone?: string;
    workplacePhoneExt?: string;
    includeMonthlyIncomes?: boolean;
    monthlyIncomes?: string;
    employmentType?: Catalog;
    documentType: Catalog;
    businessType: Catalog;
}

export interface PdfViewState {
    showLoading: boolean;
    file: PdfState;
}

export interface PdfState {
    docType: string;
    doc: string;
}

export interface Reference {
    completeName: string;
    phone: string;
}

export interface POSDataState {
    type: string;
    id: string;
    motorfyId: string;
    name: string;
    userId: string;
    userEmail: string;
    isFromWizardWeb: boolean;
    group: Catalog;
}

export type Group = Catalog;

export interface POSDataViewState {
    fieldErrors: POSViewFieldErrorState;
    requiredFields: boolean;
    isLoadingGroups: boolean;
}

export interface BureauInformationDataState {
    status: string;
    createdAt: string;
    createdBy: string;
}

export interface CommonActionExcecutedState {
    message: string
    hasError: boolean
}

export type ContinueLoanApplicationState = CommonActionExcecutedState;

export type SendLoanApplicationBankState = CommonActionExcecutedState;

export interface BankApplicationDataState {
    bankApplicationId: string;
    bankApplicationName?: string;
    bankApplicationFinishName?: string;
    acceptQuote?: string;
}

export interface GlobalApplicationDataState {
    updateAt: string;
    hasBureauError: boolean;
}

export interface CRMDataState {
    adviser: Catalog;
    dealId: number;
    dealLink: string;
    pipeline: Catalog;
    stage: Catalog;
    status: string;
    lostReason: string;
    statusDetail: Catalog;
}

export interface CalculatorDataState {
    showModal: boolean;
    showLoading: boolean;
    financingAmount: string;
    commissionAmount: string;
    monthlyPayment: string;
}

export interface FileState extends FileData {
    versionId?: string
    lastModifiedToDisplay?: string
    isSelected?: boolean
    selected?: boolean
}

export interface UploadDateState {
    displayValue: string
    value: number
}

export interface VersionFileState {
    id?: string
    size: number
    name: string
    mimeType: string
    url: string
    urlCompress: string
    details?: string
    uploadDate: UploadDateState
    ownerName?: string
}

export interface VersionState {
    name: string
    versionId: string
    documentGroups: VersionFileState[]
    openTree: boolean
    toggleTree?: Function
}

export interface DocumentTypes {
    id: string
    label: string
    info: string
    autogenerated: boolean
    classificationId: string
}

export interface AttachmentCatalogsState {
    documentTypes: DocumentTypes[]
    allDocumentTypes: DocumentTypes[]
}

export interface AttachmentsForm {
    documentsVersionId: string
    documentsVersionName: string
    documentTypeSelected: DocumentTypes
    files: FileState[]
    versions: VersionState[]
    formType: string
}

export interface AttachmentDetail {
    documentsVersionId: string
    documentTypeSelected: DocumentTypes
    files: FileState[]
}

export interface DocsUI {
    attachmentsFormView: AttachmentsFormView;
    searchBox: SearchBoxState;
    showAttachmentEditSideBar: boolean
    showAttachmentViewSideBar: boolean
}

export interface AttachmentsFormFieldErrors {
    documentTypeSelectedFieldError: string
    filesViewFieldError: string
}

export interface AttachmentsFormView {
    fieldErrors: AttachmentsFormFieldErrors
}

export interface SearchBoxState {
    searchQuery: string;
}

export interface LoanApplicationAttachmentsState {
    versionId: string;
    versionName: string;
    label: string;
    id: string;
    info: string;
    classificationId: string;
    autogenerated: boolean
    documentGroups: AttachmentFileState[]
    versions: AttachmentVersion[]
    onPressEditSidebar?: () => void
}

export interface AttachmentVersion {
    name: string
    versionId: string
    documentGroups: AttachmentFileState[]
    openTree: boolean
}

export interface AttachmentFileState {
    id: string;
    size: number;
    fileName: string;
    mimeType: string;
    originalUrl: string;
    compressUrl: string;
    thumbnailUrl: string;
    fileDetail: string;
    uploadDate: any | AttachmentUploadDateState;
    uploadUser: string;
    sentToBank: boolean;
    onPressDetailSidebar?: () => void
    onPressSendFileToBank?: () => void
    onViewFile?: () => void
    onDeleteFile?: () => void
    selected: boolean;
}

export interface AttachmentUploadDateState {
    displayValue: string
    value: number
}

export interface LoanGroupedAttachmentsState {
    classification: string;
    classificationId: string;
    documentGroups: LoanApplicationAttachmentsState[];
}

export interface PipefyDataState extends CRMDataState {
    syncBy: string
    errorMessage: string
    lastSyncDate: FormattedDate
}

export interface CalculatorValidationParameter {
    vehiclePrice: number
    downPayment: number
    minDownPayment: number
    maxDownPayment: number
    country: string
    currencySymbol?: string
    maxFinancingAmount?: number
    minFinancingAmount?: number
    checkFinancingAmount?: boolean
}
